import ContentBlock from './components/ContentBlock'
import { LoadingWrap } from 'components/Loading'
export { default as ContentBlock } from './components/ContentBlock'
export { default as ExpandableBlocks } from './components/ExpandableBlocksContainer'
export { ExpandableContext } from './components/ExpandableBlocksContainer'
export const ContentBlockLoading = LoadingWrap(ContentBlock)
export default ContentBlock
